
import request from '../untils/request';

export const buyersListApi = params => {
  return request({
    url: '/buyer/buyer/index',
    authCode: 'BUYER',
    params,
  });
};

export const buyerUsersApi = params => {
  return request({
    url: '/buyer/buyer/user',
    params,
  });
};

export const buyersCreateApi = params => {
  return request({
    url: '/buyer/buyer/create',
    params,
  });
};

export const buyersGradeEditApi = params => {
  return request({
    url: '/buyer/buyer/edit-achi',
    params,
  });
};

export const buyersDeleteApi = params => {
  return request({
    url: '/buyer/buyer/delete',
    params,
  });
};

export const buyerDetailApi = params => {
  return request({
    url: '/buyer/buyer/detail',
    params,
  });
};

export const buyerGradesTableApi = params => {
  return request({
    url: '/buyer/buyer/detail-buyer-achievement',
    authCode: 'BUYER',
    params,
  });
};

export const buyerMyGradeListApi = params => {
  return request({
    url: '/buyer/buyer/my',
    authCode: 'BUYER',
    params,
  });
};

export const buyerMyGoodsApi = params => {
  return request({
    url: '/buyer/buyer/goods',
    authCode: 'BUYER',
    params,
  });
};

export const buyerMySuppliersApi = params => {
  return request({
    url: '/buyer/buyer/supplier',
    authCode: 'BUYER',
    params,
  });
};
